import { displayBRToISO, isoToDisplayBR, orderCreatedDisplayBRToApi } from '../../../app/date';

function apiDayOrNull(v) {
  if (v == null || v === '') return null;
  const s = String(v).trim();
  if (!s) return null;
  const ymd = s.slice(0, 10);
  if (/^\d{4}-\d{2}-\d{2}$/.test(ymd)) return ymd;
  return null;
}

function deliveryDateForApi(order) {
  const d = order?.delivery_date;
  if (d && typeof d === 'string') {
    const ymd = d.trim().slice(0, 10);
    if (/^\d{4}-\d{2}-\d{2}$/.test(ymd)) return ymd;
  }
  return '';
}

/**
 * @param {Record<string, unknown>} order - getOrder response `.data`
 * @param {{ status?: string, status_transition_draft_note?: string, force_status_history_entry?: boolean }} overrides
 */
export function buildOrderUpdatePayloadFromOrderDetail(order, overrides = {}) {
  const status = overrides.status != null ? overrides.status : order?.status;
  const deliveryISO = deliveryDateForApi(order);
  const note =
    overrides.status_transition_draft_note != null ? String(overrides.status_transition_draft_note) : '';

  const payload = {
    status,
    title: order?.title ? String(order.title) : null,
    valid_until: apiDayOrNull(order?.valid_until),
    delivery_date: deliveryISO,
    observations: order?.observations != null && String(order.observations) !== '' ? order.observations : null,
    customer_id: order?.customer_id != null && String(order.customer_id).trim() !== '' ? order.customer_id : null,
    discount_value: order?.discount_value != null ? order.discount_value : null,
    status_transition_draft_note: note,
  };

  if (overrides.force_status_history_entry) {
    payload.force_status_history_entry = true;
  }

  const canCreated =
    order?.can_edit_created_at === true ||
    (!order?.order_type_id && ['DRAFT', 'SENT'].includes(String(status || '')));
  if (canCreated && order?.created_at) {
    const br = isoToDisplayBR(order.created_at);
    payload.created_at = br ? orderCreatedDisplayBRToApi(br, order.created_at) : null;
  }

  return payload;
}

export function buildOrderUpdatePayloadFromFormData(fd, curOrder, note, extra = {}) {
  const validUntilISO = fd.valid_until ? displayBRToISO(fd.valid_until) : null;
  const deliveryISO = fd.delivery_date ? displayBRToISO(fd.delivery_date) : '';
  const payload = {
    status: fd.status,
    title: fd.title ?? '',
    valid_until: validUntilISO,
    delivery_date: deliveryISO,
    observations: fd.observations || null,
    customer_id: fd.customer_id || null,
    discount_value: fd.discount_value,
    status_transition_draft_note: note,
  };
  if (curOrder?.can_edit_created_at || (!curOrder?.order_type_id && ['DRAFT', 'SENT'].includes(fd.status))) {
    payload.created_at = fd.created_at ? orderCreatedDisplayBRToApi(fd.created_at, curOrder?.created_at) : null;
  }
  return { ...payload, ...extra };
}
